import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '@breeze-ai/ui-library';
import {
  CargoProvider,
  Typography,
  UnassignedUserIllustration,
} from '@breezeai-frontend/cargo-ui';

import { useUserSetting } from '../context/auth/auth-hooks';
import { usePlatform } from '../context/PlatformContext';
import { SupportDialog } from '../ui/components/SupportDialog/SupportDialog';
import { Sidebar } from '../ui/sidebar/Sidebar';
import { initialLocale, setAppLocale } from '../utils/locale';

export const UnassignedUserPage = () => {
  const userLocale = useUserSetting<string>('locale');
  const { setLocale: setComponentsLocale } = useLocale();
  const navigate = useNavigate();
  const { platform } = usePlatform();

  useEffect(() => {
    setAppLocale(userLocale);
    setComponentsLocale?.(userLocale);

    return () => {
      setAppLocale(initialLocale);
      setComponentsLocale?.(initialLocale);
    };
  }, [setComponentsLocale, userLocale]);

  return (
    <CargoProvider
      theme={platform}
      navigate={navigate}
      userLocaleOverride={userLocale}
    >
      <div className="flex h-dvh w-dvw bg-surfaces-secondary">
        <Sidebar />
        <div
          id="main-breeze-app-frame"
          className="flex flex-col w-full overflow-auto"
        >
          <div className="w-full h-full px-10 min-w-[400px] flex flex-col justify-center items-center overflow-auto">
            <UnassignedUserIllustration />
            <div className="flex flex-col justify-center items-center gap-4 mt-10">
              {/* eslint-disable-next-line i18next/no-literal-string -- TODO fix localization */}
              <Typography level="h1">No data to display!</Typography>
              {/* eslint-disable-next-line i18next/no-literal-string -- TODO fix localization */}
              <Typography level="h4" color="secondary">
                Please contact your company’s Account Manager
              </Typography>
            </div>
          </div>
        </div>
      </div>
      <SupportDialog />
    </CargoProvider>
  );
};
